import type { SharedProps } from '@bonniernews/dn-design-system-web/assets/types/shared-props.ts'

import { formatClassString } from '@bonniernews/dn-design-system-web/helpers/formatClassString.ts'

export interface QuoteProps extends SharedProps {
  bodyHtml: string
  theme?: 'kultur' | 'nyheter'
  forcePx?: boolean
}

/**
 * - GitHub: [BonnierNews/dn-design-system/web/src/components/quote](https://github.com/BonnierNews/dn-design-system/tree/main/web/src/components/quote)
 * - Storybook: [Quote](https://designsystem.dn.se/?path=/docs/article-quote--docs)
 *
 * The component will not include styling by itself. Make sure to include the right styles for the component. See example below:
 * `@use '@bonniernews/dn-design-system-web/components/quote/quote.scss'`
 */
export const Quote = ({ bodyHtml, theme = 'nyheter', classNames, attributes, forcePx }: QuoteProps) => {
  const componentClassName = 'ds-quote'

  const classes = formatClassString([componentClassName, `ds-theme--${theme}`, forcePx && 'ds-force-px', classNames])

  const quoteHtml = `<span class="${componentClassName}__border"></span> ${bodyHtml}`

  return <blockquote dangerouslySetInnerHTML={{ __html: quoteHtml }} className={classes} {...attributes} />
}
